{
  "search": "Αναζήτηση",
  "searchWithin": "Αναζήτηση εντός"
}
